const TargetsSite = require("@/modules/targets/components/TargetsSite.vue")
  .default;
const TargetDetailSite = require("@/modules/targets/components/TargetDetailSite.vue")
  .default;
const TargetCreateSite = require("@/modules/targets/components/TargetCreateSite.vue")
  .default;
const TargetRetrySite = require("@/modules/targets/components/TargetRetrySite.vue")
  .default;
const TargetEditSite = require("@/modules/targets/components/TargetEditSite.vue")
  .default;
const TargetAddFriendsSite = require("@/modules/targets/components/TargetAddFriendsSite.vue")
  .default;
const TargetInvitationSite = require("@/modules/targets/components/TargetInvitationSite.vue")
  .default;

const TargetRoutes = [
  {
    name: "Targets",
    path: "/targets/",
    component: TargetsSite,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Target Detail",
    path: "/target/:id",
    components: { default: TargetDetailSite },
    props: { default: true },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Create Target",
    path: "/create-target",
    components: { default: TargetCreateSite },
    props: { default: true },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Retry Target",
    path: "/target-retry/:id",
    components: { default: TargetRetrySite },
    props: { default: true },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Update Target",
    path: "/update-target/:id",
    components: { default: TargetEditSite },
    props: { default: true },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Target Invite Friends",
    path: "/target-invite/:id",
    components: { default: TargetAddFriendsSite },
    props: { default: true },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Target invitation",
    path: "/target-invitation/:id",
    components: { default: TargetInvitationSite },
    props: { default: true },
    meta: {
      requiresAuth: true,
    },
  },
];

const TargetSettingsRoutes = [];

const TargetBaseDataRoutes = [];

export { TargetRoutes, TargetSettingsRoutes, TargetBaseDataRoutes };
